import * as React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { PageLoading } from "components/Layout";

const ListPage = React.lazy(() => import("./views/ListPage"));

const Routes = () => {
  const { url } = useRouteMatch();

  return (
    <React.Suspense fallback={<PageLoading />}>
      <Switch>
        <Route exact path={url}>
          <ListPage />
        </Route>
      </Switch>
    </React.Suspense>
  );
};

export default Routes;
